import { atom } from "jotai";

export const puntosAtom = atom([]);
export const resumenAtom = atom([]);
export const solicitudesPremiosAtom = atom([]);

export const openModalSolicitarPremioAtom = atom(false);
export const loadingAtom = atom(false);